'use client'
import { useEffect, useMemo, type FC } from 'react'
import { useParams, usePathname } from 'next/navigation'
import { mq, vw } from '@/styles'
import styled from 'styled-components'
import type { TypeCmsContentPage, TypeCmsProductsByCategoryList, TypeLang } from '@/schema'
import { NAVBAR_HEIGHTS } from './commons/layout/Navbar'
import { SectionNavLinks } from './SectionNavLinks'
import { usePageDesign } from '@/hooks'
import { Link } from './commons'

type Props = {
  data: {
    name: TypeCmsProductsByCategoryList['name']
    categories: TypeCmsProductsByCategoryList['categories']
  }
}

const getSubmenuList = (categories, locale) => categories.map((cat) => {
  return ({
    name: cat.name,
    pathname: `/products/${cat.slug[locale]}`,
    type: 'link',
    filters: cat.filters
  })
})

const getLinks = (data: TypeCmsContentPage['menu'], pathname, isUsa?: boolean ) => data.map((item, idx) => {
  if (!item?.pathname) return null
  const isActive = pathname.includes(item.pathname)
  return (
    <div key={idx + pathname}>
      <Link href={`${isUsa ? '/usa' : ''}${item.pathname}`} className={isActive ? 'active':''}>{item.name}</Link>
    </div>
  )
})


export const HeaderProductsCategory:FC<Props> = ({ data }) => {
  const { lang }: { lang: TypeLang } = useParams()
  const { name, categories } = data
  const submenu = useMemo(() => getSubmenuList(categories, lang), [categories, lang])
  const { setHeaderTextColor, setPageHasHeaderBgImage } = usePageDesign()
  const pathname = usePathname()
  const isUsa = useMemo(() => pathname.includes('/usa/'), [pathname])
  const Slides = useMemo(() => submenu && getLinks(submenu, pathname, isUsa), [submenu, isUsa, pathname])

  useEffect(() => {
    setHeaderTextColor('dark')
    setPageHasHeaderBgImage(false)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (
    <>
      <Header>
        <h1 className='srt-only'>Products list for category {name}</h1>
      </Header>
      {submenu && <SectionNavLinks key={pathname + submenu?.length} title='menu' slides={Slides} />}
    </>
  )
}

const Header = styled.header`
  background-color: var(--color-background);
  padding-top: ${vw(NAVBAR_HEIGHTS.mobile, 'mobile')};

  ${mq.greaterThan('nexus7')} {
    padding-top: ${vw(NAVBAR_HEIGHTS.mobile, 'tablet')};
  }

  ${mq.greaterThan('tablet')} {
    padding-top: ${vw(NAVBAR_HEIGHTS.desktop, 'desktop')};
  }

  ${mq.greaterThan('desktop')} {
    padding-top: ${NAVBAR_HEIGHTS.desktop}px;
  }
`
